var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-5"},[_c('div',{staticClass:"text-center"},[_c('p',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }